export const DESKTOP_NAV_MENU_MIN_WIDTH = 930

export const mobileViewQuery = `(max-width: ${DESKTOP_NAV_MENU_MIN_WIDTH}px)`

export const desktopViewQuery = `(min-width: ${DESKTOP_NAV_MENU_MIN_WIDTH + 1}px)`
